module.exports = __webpack_public_path__ + "img/idea-icon.7be968e8.svg";